import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-07-07 11:14:54
 * @LastEditTime: 2022-01-13 19:03:19
 * @LastEditors: wangshengqiang
 * @Description: 国籍组件
 */
import React, { useEffect, useState } from 'react'; // import { getEnumList } from '@/services/dict';

import RowSelect from '../RowSelect';
export default function RowNation(props) {
  const {
    attrs
  } = props;
  const {
    dataSource = [],
    display
  } = attrs || {};
  const {
    defaultValue,
    hasDefaultValue
  } = display || {}; // const { children, dataSource, ...rest } = props;

  let _defaultValue;

  if (defaultValue && hasDefaultValue) {
    const de = JSON.parse(defaultValue);
    _defaultValue = typeof de === 'string' ? de : de === null || de === void 0 ? void 0 : de.code;
  } // const [ds, setDs] = useState(dataSource);
  // useEffect(() => {
  //   function filterData(data) {
  //     setDs(data.filter((item) => {
  //       item.keyId = String(item.keyId);
  //       return item.category !== 0;
  //     }));
  //   }
  //   if (dataSource) {
  //     filterData(dataSource);
  //   } else {
  //     getEnumList('country').then((res) => {
  //       if (res.success) {
  //         filterData(res.result);
  //       }
  //     });
  //   }
  // }, []);


  return /*#__PURE__*/React.createElement(RowSelect, _extends({}, props, {
    valueMember: "code",
    textMember: "name",
    defaultInitialValue: _defaultValue,
    dataSource: dataSource
  }));
}